/* tslint:disable */
/* eslint-disable */
/**
 * Stadia Maps Geospatial APIs
 * The Stadia Maps Geospatial APIs provide you with the data you need to build awesome applications.
 *
 * The version of the OpenAPI document: 9.3.0
 * Contact: support@stadiamaps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface FoursquareAddendum
 */
export interface FoursquareAddendum {
  /**
   *
   * @type {string}
   * @memberof FoursquareAddendum
   */
  tel?: string | null;
  /**
   *
   * @type {string}
   * @memberof FoursquareAddendum
   */
  website?: string | null;
}

/**
 * Check if a given object implements the FoursquareAddendum interface.
 */
export function instanceOfFoursquareAddendum(
  value: object,
): value is FoursquareAddendum {
  return true;
}

export function FoursquareAddendumFromJSON(json: any): FoursquareAddendum {
  return FoursquareAddendumFromJSONTyped(json, false);
}

export function FoursquareAddendumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): FoursquareAddendum {
  if (json == null) {
    return json;
  }
  return {
    tel: json["tel"] == null ? undefined : json["tel"],
    website: json["website"] == null ? undefined : json["website"],
  };
}

export function FoursquareAddendumToJSON(json: any): FoursquareAddendum {
  return FoursquareAddendumToJSONTyped(json, false);
}

export function FoursquareAddendumToJSONTyped(
  value?: FoursquareAddendum | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    tel: value["tel"],
    website: value["website"],
  };
}
